import ModelService from "./abstract/ModelService";
import Depot from "../models/Depot";

export default class DepotService extends ModelService {
    constructor() {
        super('/depots', Depot);
    }
}